import { WS_EVENT_TYPES } from "@/utils/constants";

export const ozlContractSocketService = {
  [WS_EVENT_TYPES.CONTRACT_ACCEPTED_EVENT]() {},
  [WS_EVENT_TYPES.CONTRACT_CREATE_EVENT](data) {
    this.items.unshift(data);
    this.items.splice(0, 1, data);
    this.setSuccess({ text: this.$t("addedNewContract") });
  },
  [WS_EVENT_TYPES.CONTRACT_REJECTED_EVENT](data) {
    const { id } = data;
    const contractIndex = this.items.findIndex((item) => item.id === id);
    if (contractIndex !== -1) {
      let contract = this.items[contractIndex];
      this.items.splice(contractIndex, 1, { ...contract, ...data });
    }
  },
};
